<template>
  <div class="home-page">
    <NavbarComponent @selected="handleSelected" />
    <div class="projects-display">
      <ProjectsGrid :projects="projects" />
    </div>
    <MobileBottomNav />
  </div>
</template>

<style scoped>
.home-page {
  padding: 0 60px 0 60px;
  touch-action: none;
}

.projects-display {
  display: flex;
  gap: 12px;
  width: fit-content;
  padding: 75px 0 0 0;
  margin: auto;
}

@media (max-width: 1260px) {
  .home-page {
    padding: 0 45px 0 45px;
  }
}

@media (max-width: 996px) {
  .home-page {
    padding: 0 45px 0 45px;
    overflow: hidden;
  }

  .projects-display {
    padding-top: 33px;
  }
}

@media (max-width: 520px) {
  .home-page {
    padding: 0 18px 0 18px;
  }
}
</style>

<script setup>
import NavbarComponent from '@/components/organisms/navbar-component.vue';
import ProjectsGrid from '@/components/organisms/projects-grid.vue';
import { ref, onBeforeMount } from 'vue';
import useSanity from '@/composables/useSanity';
import MobileBottomNav from '@/components/molecules/mobile-bottom-nav.vue';

let fetchedProjects;
const projects = ref(null)

const { getProjects, isLoading } = useSanity()

onBeforeMount(async () => {
  fetchedProjects = await getProjects()
  projects.value = fetchedProjects
});

function handleSelected(categories) {
  if (!categories?.length) {
    projects.value = fetchedProjects
    return
  }

  projects.value = []
  for (const project of fetchedProjects) {
    const hasCategory = project.categories.some(projectCategory => categories.includes(projectCategory))

    if (hasCategory) {
      projects.value.push(project)
    }
  }
}
</script>
